import { render, staticRenderFns } from "./Condominios.vue?vue&type=template&id=5c536b8e&scoped=true&"
import script from "./condominios.js?vue&type=script&lang=js&"
export * from "./condominios.js?vue&type=script&lang=js&"
import style0 from "./Condominios.vue?vue&type=style&index=0&id=5c536b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c536b8e",
  null
  
)

export default component.exports